import { Box, Paper, makeStyles } from "@material-ui/core"
import { MemberIdentity } from "./MemberIdentity"
import { RoleSelector } from "./RoleSelector"
import { HourReportingRolesTranslations } from "../hooks/use-translations"
import { HourReportingRoleRow, RoleAssignmentKind, RoleSelectorOption } from "../types"

type HourReportingRolesCardsProps = {
  orgId: string
  rows: HourReportingRoleRow[]
  translations: HourReportingRolesTranslations
  canUpdateAssignments: boolean
  supportsChecking: boolean
  isAssignmentPending: (memberId: string, kind: RoleAssignmentKind) => boolean
  onOpenRoleDetails: (memberId: string) => void
  onUpdateAssignment: (memberId: string, kind: RoleAssignmentKind, selectedMembers: RoleSelectorOption[]) => void
}

export const HourReportingRolesCards = ({
  orgId,
  rows,
  translations,
  canUpdateAssignments,
  supportsChecking,
  isAssignmentPending,
  onOpenRoleDetails,
  onUpdateAssignment,
}: HourReportingRolesCardsProps) => {
  const classes = useStyles()

  const showCheckingField = supportsChecking && canUpdateAssignments
  const showApprovingField = canUpdateAssignments

  return (
    <div className={classes.cardList} data-org-id={orgId}>
      {rows.map((row) => (
        <Paper key={row.member.id} variant="outlined" className={classes.card}>
          <MemberIdentity
            member={row.member}
            checkerCount={row.reporterDetails.checkedReporters.length}
            approverCount={row.reporterDetails.approvedReporters.length}
            translations={translations}
            supportsChecking={supportsChecking}
            onOpenRoleDetails={() => onOpenRoleDetails(row.member.id)}
          />
          {showCheckingField && (
            <Box mt={2}>
              <RoleSelector
                label={translations.checkersHeaderText}
                roleType="checker"
                options={row.roleOptions}
                selectedMembers={row.selectedCheckers}
                disabled={!canUpdateAssignments || isAssignmentPending(row.member.id, "checker")}
                onChange={(selectedMembers) => onUpdateAssignment(row.member.id, "checker", selectedMembers)}
                translations={translations}
              />
            </Box>
          )}
          {showApprovingField && (
            <Box mt={2}>
              <RoleSelector
                label={translations.approversHeaderText}
                roleType="approver"
                options={row.roleOptions}
                selectedMembers={row.selectedApprovers}
                disabled={!canUpdateAssignments || isAssignmentPending(row.member.id, "approver")}
                onChange={(selectedMembers) => onUpdateAssignment(row.member.id, "approver", selectedMembers)}
                translations={translations}
              />
            </Box>
          )}
        </Paper>
      ))}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  cardList: {
    marginTop: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
  },
}))
